export const linkNamesHeader = [
  'About me',
  'Relationships',
  'Requirements',
  'Users',
  'Sign Up',
];

export const linkNamesMenu1 = [
  'About me',
  'Relationships',
  'Users',
  'Sign Up',
  'Terms and Conditions',
];

export const linkNamesMenu2 = [
  'How it works',
  'Partnership',
  'Help',
  'Leave testimonial',
  'Contact us',
];

export const linkNamesMenu3 = [
  'How it works',
  'Partnership',
  'Help',
  'Leave testimonial',
  'Contact us',
];
